const SectionCard = ({ product }) => (
  <a className="section-card" href={product.url} target="_blank" rel="noreferrer">
    <img src={product.logo} alt={product.name} />
    <div className="title">{product.name}</div>
  </a>
);

export default SectionCard;
